import React from 'react';
import OwnerWalletPnlCards from '../wallets/OwnerWalletPnlCards';

type SuperAgentWalletPnlCardsProps = {
  superAgentId: string;
  enabled?: boolean;
};

/** @deprecated Prefer OwnerWalletPnlCards — kept for Super Agent detail imports. */
export const SuperAgentWalletPnlCards: React.FC<SuperAgentWalletPnlCardsProps> = ({
  superAgentId,
  enabled = true,
}) => <OwnerWalletPnlCards ownerType="super_agent" ownerId={superAgentId} enabled={enabled} />;

export default SuperAgentWalletPnlCards;
